import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import RecipeCard from '../components/RecipeCard';
import api from '../utils/api';
import './Home.css';

export default function Home() {
  const { user } = useAuth();
  const [recipes, setRecipes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/recipes/latest')
      .then(res => setRecipes(res.data.recipes || []))
      .catch(() => setError('Failed to load recipes'))
      .finally(() => setLoading(false));
  }, []);

  const featured = recipes.slice(0, 3);
  const rest = recipes.slice(3);

  if (loading) {
    return (
      <div className="page-loading">
        <div className="spinner" />
        <span>Loading your recipes...</span>
      </div>
    );
  }

  return (
    <div className="home">
      {/* Hero Banner - editable section */}
      <div className="home__hero">
        <div className="container">
          <div className="home__hero-content">
            <h1>Welcome back, {user?.name?.split(' ')[0]}! 👋</h1>
            <p>You have <strong>{recipes.length}</strong> recipe{recipes.length !== 1 ? 's' : ''} in your collection.</p>
            <p className="home__hero-hint">
              📱 Text <code>[recipe] URL</code> to your Telegram bot to save a new recipe
            </p>
          </div>
        </div>
      </div>

      <div className="container">

        {error && <div className="error-state"><p>{error}</p></div>}

        {recipes.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">🍽️</div>
            <h3>No recipes yet!</h3>
            <p>Send a recipe URL to your Telegram bot to get started.</p>
            <p style={{marginTop: '8px', fontSize: '0.875rem', color: 'var(--color-text-muted)'}}>
              Example: <code>[recipe] https://www.allrecipes.com/...</code>
            </p>
          </div>
        ) : (
          <>
            {/* Featured Recipes - top 3 */}
            {featured.length > 0 && (
              <section className="home__section">
                <div className="home__section-header">
                  <h2>Recently Added</h2>
                  <Link to="/search" className="home__see-all">See all →</Link>
                </div>
                <div className="home__featured-grid">
                  {featured.map((recipe, i) => (
                    <RecipeCard key={recipe.id} recipe={recipe} featured={i === 0} />
                  ))}
                </div>
              </section>
            )}

            {/* Rest of recipes */}
            {rest.length > 0 && (
              <section className="home__section">
                <div className="home__section-header">
                  <h2>More Recipes</h2>
                </div>
                <div className="home__grid">
                  {rest.map(recipe => (
                    <RecipeCard key={recipe.id} recipe={recipe} />
                  ))}
                </div>
              </section>
            )}
          </>
        )}
      </div>
    </div>
  );
}
